import { render, staticRenderFns } from "./ChuRuReport.vue?vue&type=template&id=0d55b66a&scoped=true&"
import script from "./ChuRuReport.vue?vue&type=script&lang=js&"
export * from "./ChuRuReport.vue?vue&type=script&lang=js&"
import style0 from "./ChuRuReport.vue?vue&type=style&index=0&id=0d55b66a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d55b66a",
  null
  
)

export default component.exports